export const /** MessagesBox styles */ messagesBoxStyles = {
    message: {
        boxSizing: 'border-box',
        width: '100%',
        color: '#191C1B',
        '& p': {
            padding: '0',
            margin: '1rem 0 0',
        },
        '& > p:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child': {
            margin: '0',
        },
        '& > h1:first-child': {
            margin: '0.25rem 0 0',
        },
        '& li': {
            margin: '1rem 0 0',
        },
        '& pre': {
            backgroundColor: 'rgba(0, 107, 84, 0.11)',
            padding: '1rem',
            borderRadius: '1rem',
            width: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        },
        '& table': {
            boxSizing: 'border-box',
            overflow: 'hidden',
            borderCollapse: 'separate',
            borderRadius: '1rem',
            border: '1px solid #BFC9C3',
            borderSpacing: '0',
            margin: '1rem 0',
            'thead': {
                'tr': {
                    boxShadow: '0 0 2px #BFC9C3',
                    'th': {
                        padding: '1rem',
                        border: '0',
                    },
                },
                backgroundColor: 'rgba(0, 107, 84, 0.08)',
            },
            'tbody': {
                'tr': {
                    'td': {
                        padding: '1rem',
                    },
                    backgroundColor: '#ffffff',
                    boxShadow: '0 0 2px #BFC9C3',
                },
            },
        },
    },
};
